import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import Modal2 from 'components/modals/Modal2/Modal2';
import { ReactComponent as DangerIcon } from 'assets/icons/danger.svg';
import { AccountsContext } from '../../contexts/AccountsContext';

function ModalDeleteAccount() {
  const { formatMessage: t } = useIntl();
  const {
    isModalDeleteAccountOpen,
    handleCloseModalDeleteAccount,
    deleteAccount,
    isDeleting,
  } = useContext(AccountsContext);
  return (
    <Modal2
      isOpen={isModalDeleteAccountOpen}
      size="large"
      onClose={handleCloseModalDeleteAccount}
      icon={(<DangerIcon />)}
      loading={isDeleting}
      title={t({ id: 'modal.deleteAccount.title' })}
      subtitle={t({ id: 'modal.deleteAccount.subtitle' })}
      modalType="warning"
      actions={[
        {
          label: 'button.deleteAccount',
          showLoading: true,
          onClick: deleteAccount,
        },
        {
          label: 'button.cancel',
          type: 'secondaryOutline',
          showLoading: false,
          onClick: handleCloseModalDeleteAccount,
        },
      ]}
    />
  );
}

export default ModalDeleteAccount;



// WEBPACK FOOTER //
// ./routes/cpm/routes/accounts/components/ModalDeleteAccount/ModalDeleteAccount.jsx